import { Component } from '@angular/core';

@Component({
    selector: 'app-anam-agent',
    standalone: true,
    template: `
    <div class="relative flex h-full w-full bg-black overflow-hidden">
      <iframe
        src="https://lab.anam.ai/frame/95c02e5b-486c-42a7-b4f0-1c1c729cf02e"
        allow="microphone"
        style="width:100%;height:100%;border:none;display:block;">
      </iframe>
      <div
        aria-hidden="true"
        class="pointer-events-none absolute bottom-0 left-0 right-0"
        style="z-index:2;height:112px;background:#ffffff;">
      </div>
      <div
        aria-hidden="true"
        class="pointer-events-none absolute left-0 right-0"
        style="z-index:3;bottom:96px;height:54px;background:#ffffff;">
      </div>
    </div>
  `
})
export class AnamAgentComponent { }
